<template>
  <div class="m-form-group">
    <label class="a-form-label" for="heardAbout">{{ $t('heard-about') }}</label>
    <select class="a-form-control" id="heardAboutSelect" v-model="heardAbout">
      <option v-for="item in textItems" :key="item.value" :value="item.value" :disabled="item.isDisabled">{{ $t(item.text) }}</option>
    </select>
  </div>
</template>

<script>
import { HeardAboutMixin } from '@/mixins/form/heard-about'

export default {
  mixins: [HeardAboutMixin],
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    heardAbout: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
